import { Slider as AntdSlider, ConfigProvider, SliderSingleProps } from 'antd';
import React, { ReactElement } from 'react';

export default function Slider(props: SliderSingleProps): ReactElement {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Slider: {
                        handleSize: 14,
                        handleSizeHover: 20,
                        railSize: 6,
                    },
                },
            }}
        >
            <AntdSlider
                {...props}
            />
        </ConfigProvider>
    );
}